// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    INotificationItem,
}                               from '../interfaces';

const getAnnotationUnreadNotifications = async ({
    test,
    annotationId,
}: {
    test: boolean,
    annotationId: string,
}): Promise<INotificationItem[]> => {
    const functions = getFunctions();
    const handleGetAnnotationUnreadNotifications = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        INotificationItem[]
    >(
        functions,
        'getAnnotationUnreadNotifications',
    );
    return handleGetAnnotationUnreadNotifications({
        test,
        annotationId,
    }).then((result) => {
        const notifications = result.data as INotificationItem[];
        return notifications;
    }).catch((err) => {
        throw err;
    });
};

export default getAnnotationUnreadNotifications;
